const Icon = ({ name, size = 14, style = {} }) => (
  <i
    className={`ti ti-${name}`}
    style={{ fontSize: size, lineHeight: 1, ...style }}
    aria-hidden="true"
  />
);
export default Icon;